module.exports = __webpack_public_path__ + "static/media/user_icon.f3a30fc1.svg";